// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1067":"de1e16d9","3427":"f0cd0ed5","4769":"de1e16d9","5583":"de1e16d9"}[chunkId] + ".chunk.css";
};